import React from "react";
import CLabel from "../CLabel";
import cssClasses from "./CustomSelect.module.css";
import baseCssClasses from "../../common/FormBase.module.css";
import { ChevronDownIcon } from "@heroicons/react/16/solid";
import CustomMenu from "../CustomMenu";
import CustomCheckbox from "../CustomCheckbox";

const CustomSelectBasic = ({
  label,
  value = "",
  onChange,
  menuList = [],
  disabled = false,
  required = false,
  placeholder = "",
  name = "",
  children,
  handleToggle: _handleToggle,
  error = false,
  errorMessage = null,
  endIcon = null,
  multiple = false,
  width,
  height,
  labelClassName="",
}) => {
  const handleToggle = () => {
    _handleToggle?.();
  };

  // 🔐 Ensuring `safeValue` behaves properly
  const safeValue = multiple
    ? Array.isArray(value)
      ? value
      : value
        ? [value]
        : []
    : value;

  return (
    <div className="flex-1 relative flex-col flex gap-1">
      <CustomMenu
        disabled={disabled}
        wrapperStyle={{ width: width ? width : "auto" }}
        contentStyle={{ width: "100%", height: height ? height : "auto" }}
        label={
          <div className={`${error ? baseCssClasses.error : ""}`}>
            <CLabel label={label} required={required} />
            <div
              className={`${disabled ? "cursor-not-allowed" : ""} ${baseCssClasses.wrapper
                } ${labelClassName}`}
              onClick={() => !disabled && handleToggle()}
            >
              {disabled && <div className={cssClasses.disabledOverlay}></div>}

              {/* <span className={cssClasses.input}>{value || placeholder}</span> */}

              {/* uncomment this */}
              {
                <span className={`${cssClasses.input} flex items-center text_ellipsis`}>
                  {multiple
                    ? value.map((e) => menuList.find((m) => e == m.value)?.label).join(', ') || placeholder
                    : menuList.find((option) => option.value === value)
                      ?.label || placeholder}
                </span>
              }

              {!disabled && (
                <span
                  className={`${baseCssClasses.icon} ${baseCssClasses.endIcon}`}
                >
                  {endIcon?.props?.isPinCodeLoading ? (
                    endIcon
                  ) : (
                    <ChevronDownIcon />
                  )}
                </span>
              )}
            </div>
          </div>
        }
      >
        {({ handleToggle }) =>
          menuList?.map((option, index) => (
            <div
              key={index}
              className={`${baseCssClasses.option} flex gap-2`}
              onMouseDown={() => {
                if (multiple) {
                  // console.log("sasaa",value,option.value, option );

                  let newSelectedValues;
                  if (value?.includes(option.value)) {
                    newSelectedValues = value?.filter(
                      (val) => val !== option.value
                    );
                  } else {
                    newSelectedValues = [...value, option.value];
                  }

                  onChange?.({
                    target: {
                      value: newSelectedValues,
                      name: name,
                      label: option.label,
                    },
                    newSelectedValues,
                  });
                } else {
                  onChange?.({
                    target: {
                      value: option.value,
                      name: name,
                      label: option.label,
                    },
                  });
                  handleToggle();
                }
              }}
            >
              {multiple && (
                <CustomCheckbox checked={value?.includes(option.value)} />
              )}
              {option.label}
            </div>
          ))
        }
      </CustomMenu>

      {typeof children === "function" ? children({}) : children}
      {error && <CLabel error label={errorMessage} />}
    </div>
  );
};

export default CustomSelectBasic;
